import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import InputCom from "../Helpers/InputCom";
import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "../../api/axios";

export default function CheckoutSuccess() {
  window.scrollTo(0, 0);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const trnId = searchParams.get("trnId");
  const status = searchParams.get("status");
  const [order, setOrder] = useState({});
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orderId) {
      navigate("/");
      return;
    }

    const fetchOrderDetails = async () => {
      try {
        let response;
        // Check if this is a PayHere order
        if (orderId.startsWith("ph-")) {
          console.log("PayHere order");
          console.log(orderId);
          const actualOrderId = orderId.replace("ph-", "");
          response = await axios.get(`/orders/payhere/${actualOrderId}`);
        }
        // Check if this is a Koko order
        else if (trnId && status) {
          response = await axios.get(`/orders/koko/${orderId}`);
        } else {
          response = await axios.get(`/orders/${orderId}`);
        }

        console.log("Retrieved order details");
        console.log(response.data);
        if (response.data && response.data.length > 0) {
          const orderData = response.data[0];

          // Check if order status indicates a failure
          if (
            orderData.status === "failed" ||
            orderData.status === "cancelled" ||
            orderData.status === "rejected"
          ) {
            navigate(
              `/checkout-fail?orderId=${orderId}&error=Order ${orderData.status}`
            );
            return;
          }

          setOrder({
            id: orderData.id,
            subtotal:
              orderData.discounted_subtotal ||
              orderData.order_total - (orderData.shipping_fee || 0),
            shippingFee: orderData.shipping_fee || 200,
            total: orderData.order_total,
            status: orderData.status,
            payment_method: orderData.payment_method,
            discount: orderData.discount_amount || 0,
            discountCode: orderData.discount_code,
          });
          setItems(orderData.items || []);
        } else {
          // No order found
          navigate(`/checkout-fail?error=Order not found`);
          return;
        }
      } catch (error) {
        console.error("Error fetching order details:", error);
        toast.error("Could not load order details");
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [orderId, trnId, status, navigate]);

  if (loading) {
    return (
      <Layout childrenClasses="pt-0 pb-0">
        <div
          className="checkout-page-wrapper w-full bg-white pb-[60px] flex justify-center items-center"
          style={{ minHeight: "300px" }}
        >
          <p>Loading order details...</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout childrenClasses="pt-0 pb-0">
      <div className="checkout-page-wrapper w-full bg-white pb-[60px]">
        <div className="w-full mb-5">
          <PageTitle
            title="Thank You for Your Order! Your order has been successfully placed."
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "checkout-success", path: "/checkout-success" },
            ]}
          />
        </div>
        <div className="checkout-main-content w-full">
          <div className="container-x mx-auto">
            <div className="w-full lg:flex lg:space-x-[30px]">
              <div className="flex-1">
                <h1 className="sm:text-2xl text-xl text-qblack font-medium mb-5">
                  Order #{order.id}
                </h1>

                <div className="w-full px-10 py-[30px] border border-[#EDEDED]">
                  <div className="sub-total mb-6">
                    <div className=" flex justify-between mb-5">
                      <p className="text-[13px] font-medium text-qblack uppercase">
                        Product
                      </p>
                      <p className="text-[13px] font-medium text-qblack uppercase">
                        total
                      </p>
                    </div>
                    <div className="w-full h-[1px] bg-[#EDEDED]"></div>
                  </div>
                  <div className="product-list w-full mb-[30px]">
                    <ul className="flex flex-col space-y-5">
                      {items.length > 0 &&
                        items.map((product, index) => (
                          <li key={index}>
                            <div className="flex justify-between items-center">
                              <div>
                                <h4 className="text-[15px] text-qblack mb-2.5">
                                  {product.product_name}
                                  <sup className="text-[13px] text-qgray ml-2 mt-2">
                                    x{product.quantity}
                                  </sup>
                                </h4>
                                <p className="text-[13px] text-qgray">
                                  {product.brand}{" "}
                                  {product.color ? `, ${product.color}` : ""}
                                  {product.size ? `, ${product.size}` : ""}
                                </p>
                              </div>
                              <div>
                                <span className="text-[15px] text-qblack font-medium">
                                  {product.price} LKR
                                </span>
                              </div>
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                  <div className="w-full h-[1px] bg-[#EDEDED]"></div>

                  <div className="mt-[30px]">
                    <div className=" flex justify-between mb-5">
                      <p className="text-[13px] font-medium text-qblack uppercase">
                        SUBTOTAL
                      </p>
                      <p className="text-[15px] font-medium text-qblack uppercase">
                        {order.subtotal} LKR
                      </p>
                    </div>
                  </div>

                  {/* Discount section */}
                  {order.discount > 0 && (
                    <div className="mt-[30px]">
                      <div className=" flex justify-between mb-5">
                        <p className="text-[13px] font-medium text-qblack uppercase">
                          DISCOUNT{" "}
                          {order.discountCode && `(${order.discountCode})`}
                        </p>
                        <p className="text-[15px] font-medium text-green-600 uppercase">
                          -{order.discount} LKR
                        </p>
                      </div>
                    </div>
                  )}

                  <div className="w-full mt-[30px]">
                    <div className="sub-total mb-6">
                      <div className=" flex justify-between mb-5">
                        <div>
                          <span className="text-xs text-qgraytwo mb-3 block">
                            SHIPPING
                          </span>
                          {/* <p className="text-base font-medium text-qblack">
                            Free Shipping
                          </p> */}
                        </div>
                        <p className="text-[15px] font-medium text-qblack">
                          +{order.shippingFee} LKR
                        </p>
                      </div>
                      <div className="w-full h-[1px] bg-[#EDEDED]"></div>
                    </div>
                  </div>

                  <div className="mt-[30px]">
                    <div className=" flex justify-between mb-5">
                      <p className="text-2xl font-medium text-qblack">Total</p>
                      <p className="text-2xl font-medium text-qred">
                        {order.total} LKR
                      </p>
                    </div>
                  </div>

                  {/* Bank Transfer Payment Instructions */}
                  {order && order.payment_method === "BANK" && (
                    <div className="mt-[30px] p-6 bg-gray-50 border border-gray-200 rounded-lg">
                      <h3 className="text-lg font-semibold text-qblack mb-4">
                        Payment Instructions (Bank Transfer Only)
                      </h3>
                      <p className="text-sm text-qgray mb-4">
                        Please transfer the total amount to the following
                        account within <span className="font-bold">3 days</span>{" "}
                        of placing your order.
                        <span className="font-bold">
                          Shipping will commence once the payment has been
                          confirmed.
                        </span>{" "}
                        Kindly{" "}
                        <span className="font-bold">
                          use your Order ID as the payment reference
                        </span>{" "}
                        to avoid delays.
                      </p>

                      <div className="bg-white p-4 rounded border">
                        <h4 className="font-medium text-qblack mb-3">
                          Bank Details:
                        </h4>
                        <div className="space-y-2 text-sm">
                          <div className="flex">
                            <span className="text-qgray w-32">
                              Account Name:
                            </span>
                            <span className="font-medium text-qblack">
                              ZOKO ASIA (PRIVATE) LIMITED
                            </span>
                          </div>
                          <div className="flex">
                            <span className="text-qgray w-32">
                              Account Number:
                            </span>
                            <span className="font-medium text-qblack">
                              1000325926
                            </span>
                          </div>
                          <div className="flex">
                            <span className="text-qgray w-32">Bank:</span>
                            <span className="font-medium text-qblack">
                              Commercial Bank
                            </span>
                          </div>
                          <div className="flex">
                            <span className="text-qgray w-32">Branch:</span>
                            <span className="font-medium text-qblack">
                              Kollupitiya Branch
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                        <p className="text-sm text-blue-800 font-medium">
                          Please WhatsApp your bank slip to:{" "}
                          <span className="font-bold">0777144288</span>
                        </p>
                        <p className="text-xs text-blue-600 mt-1">
                          This helps us confirm your payment and process your
                          order.
                        </p>
                      </div>
                    </div>
                  )}

                  <button
                    onClick={() => navigate("/all-products")}
                    className="mt-[30px]"
                  >
                    <div className="w-full h-[50px] black-btn flex justify-center items-center px-6">
                      <span className="text-sm font-semibold">
                        Continue Shopping
                      </span>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
